export const formatFileNamesDetail = (files) =>
  (Array.isArray(files) ? files : [])
    .map((file) => file?.name || "")
    .filter(Boolean)
    .join(", ");

export const buildFileUsageMeta = ({ mode, reply, source, propertyId, files }) => ({
  mode,
  reply: !!reply,
  detail: formatFileNamesDetail(files),
  source,
  property_id: propertyId || 0,
});
